import locationform from './locationform';
import {cancelButton} from '../../../../app-components/action/CloseAction';
import {save} from '../../../../app-components/action/SaveAction';

let header = {
  title: 'Edit Clinic Location',
  actions: [cancelButton(), save()],
};
export default locationform({header});
